import { InvoicePaymentStatus } from '@/types';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

type Props = {
  status: InvoicePaymentStatus;
};

const getInvoiceStatus = (status: InvoicePaymentStatus) => {
  if (status === InvoicePaymentStatus.FULLY_PAID)
    return { color: 'green', translation: 'table.paid' };
  if (status === InvoicePaymentStatus.OVERDUE)
    return { color: 'orange', translation: 'table.overdue' };
  return { color: 'yellow', translation: 'table.not-paid' };
};

export default function InvoicesStatusCell({ status }: Props) {
  const { t } = useTranslation('invoice');

  const { color, translation } = getInvoiceStatus(status);

  return <Tag color={color}>{t(translation)}</Tag>;
}
